import { PoStorageService } from '@po-ui/ng-storage';

export interface IFiltroPedidosBloqueadosLista {
  lastSetDefault: Date;

  DC5EMISSAO_DE: Date | undefined;
  DC5EMISSAO_ATE: Date | undefined;
  CC5NUM: string;
  CC5CLIENTE: string;
  CC5LOJACLI: string;
  CC5CLIENTELOJA: string;
}

export class FiltroPedidosBloqueadosLista {

  dados: IFiltroPedidosBloqueadosLista;
  storageName: string;

  constructor(private poStorageService: PoStorageService) {

    this.dados = this.setDefault();
    this.storageName = 'interface-filtro-lista-pedido';

    this.poStorageService.get(this.storageName).then((filtro: IFiltroPedidosBloqueadosLista) => {
      if (filtro) {

        const {
          lastSetDefault,
          DC5EMISSAO_DE,
          DC5EMISSAO_ATE,
        } = filtro;

        if (!lastSetDefault && (new Date().getDay() - new Date(lastSetDefault).getDay())) {
          this.dados = this.setDefault();
        } else {
          this.dados = {
            ...filtro,
            lastSetDefault: new Date(lastSetDefault),
            DC5EMISSAO_DE: DC5EMISSAO_DE ? new Date(DC5EMISSAO_DE) : undefined,
            DC5EMISSAO_ATE: DC5EMISSAO_ATE ? new Date(DC5EMISSAO_ATE) : undefined,
          };
        }
      }
    });
  }

  public setDefault = (): IFiltroPedidosBloqueadosLista => {
    return {
      lastSetDefault: new Date(),
      DC5EMISSAO_DE: this.getData(-7),
      DC5EMISSAO_ATE: new Date(),
      CC5NUM: '',
      CC5CLIENTE: '',
      CC5LOJACLI: '',
      CC5CLIENTELOJA: '',
    };
  }

  public setStorage = (): void => {
    this.poStorageService.set(this.storageName, this.dados);
  }

  private getData = (dias: number): Date => {
    const dataDe = new Date();
    dataDe.setDate(dataDe.getDate() + dias);
    return dataDe;
  }

}
